import { render } from "./LabelsLayer.vue?vue&type=template&id=6a9bb1ea&ts=true"
import script from "./LabelsLayer.vue?vue&type=script&lang=ts"
export * from "./LabelsLayer.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__